export default __webpack_public_path__ + "ea780b72b20c109a05591a42ec6e4f07.svg";